// Mouse buttons: 0=left, 1=middle, 2=right (matches DOM MouseEvent.button).
export type ControlPacket =
  | { t: 'mv'; x: number; y: number }                               // mouse move, normalized [0..1] — LOSSY
  | { t: 'btn'; x: number; y: number; b: 0 | 1 | 2; down: boolean } // button down/up at a point
  | { t: 'wheel'; dx: number; dy: number }                          // scroll deltas (pixels)
  | { t: 'key'; code: string; down: boolean }                       // DOM KeyboardEvent.code
  | { t: 'text'; v: string }                                        // unicode text commit
  | { t: 'clip'; v: string }                                        // clipboard sync (active session only)

export interface DecodedEnvelope {
  sessionId: string
  packet: ControlPacket
}

// Only mouse-move is droppable; every state-changing packet must be delivered.
export function isReliable(p: ControlPacket): boolean {
  return p.t !== 'mv'
}

export function encodePacket(sessionId: string, packet: ControlPacket): Uint8Array {
  return new TextEncoder().encode(JSON.stringify({ s: sessionId, p: packet }))
}

export function decodePacket(data: Uint8Array): DecodedEnvelope | null {
  try {
    const o = JSON.parse(new TextDecoder().decode(data))
    if (!o || typeof o.s !== 'string' || !o.p || typeof o.p.t !== 'string') return null
    return { sessionId: o.s, packet: o.p as ControlPacket }
  } catch {
    return null
  }
}
